import Collections from '../../utils/collections';
import BaseDocument from '../../Model/BaseDocument';

const CheckInThemeUsage = {
  none: 'none',
  original: 'original',
  edited: 'edited',
};

class CheckinFeedback extends BaseDocument {
  constructor(id, opts) {
    super(`${Collections.CHECK_IN_FEEDBACK}/${id}`, opts);
  }

  get aiFeedbackText() {
    return this.data.aiFeedbackText || '';
  }

  get feedbackText() {
    return this.data.feedbackText || '';
  }

  get user() {
    return this.data.user;
  }

  get coach() {
    return this.data.coach;
  }

  get createdAt() {
    return this.data.createdAt?.toDate();
  }

  get updatedAt() {
    return this.data.updatedAt?.toDate();
  }

  get checkInSubmittedAt() {
    return this.data.checkInSubmittedAt?.toDate();
  }

  get sentAt() {
    return this.data.sentAt?.toDate();
  }

  get sentFeedbackText() {
    return this.data.aiFeedbackText || '';
  }

  get messages() {
    return this.data.messages || [];
  }

  get entriesAt() {
    return this.data.entriesAt || [];
  }

  get regeneratedCount() {
    return this.data.regeneratedCount || 0;
  }

  get totalTimeSpent() {
    return this.data.totalTimeSpent || 0;
  }

  get customFeedbackText() {
    return this.data.customFeedbackText || '';
  }

  get draftFeedbackText() {
    return this.data.draftFeedbackText || '';
  }

  get draftSmartFeedbackText() {
    return this.data.draftSmartFeedbackText || '';
  }

  get attachments() {
    return this.data.attachments || [];
  }

  get isFirstCheckIn() {
    return this.data.isFirstCheckIn || false;
  }

  /**
   * The document id holding one coach's reply to a check-in. The server and the migration spell
   * the same format, so it is written once on this side too.
   *
   * @param {string} checkInId - The check-in the reply is about.
   * @param {string} coachId - The coach replying.
   * @return {string}
   */
  static buildId(checkInId, coachId) {
    return `${checkInId}_${coachId}`;
  }

  /**
   * One coach's draft and sent reply for a check-in. Two coaches replying to the same check-in
   * each have their own document, so the coach is part of its address.
   */
  static async getByCheckInAndCoach(checkInId, coachId) {
    const checkInFeedbackDoc = new CheckinFeedback(CheckinFeedback.buildId(checkInId, coachId));
    await checkInFeedbackDoc.init();
    return checkInFeedbackDoc.exists ? checkInFeedbackDoc : null;
  }
}

export default CheckinFeedback;
export { CheckInThemeUsage };
